<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { cloneDeep, groupBy } from "lodash";
import { Carousel, Slide } from "vue-carousel";
import Loader from "@/components/widgets/loader.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    page: {
        title: "My Actual Budget Items",
    },
    components: {
        Layout,
        PageHeader,
        Carousel,
        Slide,
        Loader,
        ApiResourceLogs,
        PrintOptions,
        MaskedInput,
        RawData
    },
    data() {
        return {
            title: "My Actual Budget Items",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "My Actual Budget Items",
                    active: true,
                },
            ],
            budgetData: [],
            modalTitle: "",
            currentPageBudget: 1,
            perPageBudget: 10,
            pageOptions: [10, 25, 50, 100],
            filterBudget: "",
            filterOn: [],
            form: {
                id: 0,
            },
            indexSelected: -1,
            tableBusy: false,
            selectedBudget: "",
            selectedBudgetAmount: 0,
            selectedBudgetId: 0,
            selectedPPMPStatus: "",
            // items
            itemList: [],
            filterItem: "",
            perPageItem: 10,
            currentPageItem: 1,
            resourceItems: [],
            bliExpired: false,
            itemLoading: false,
            item: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                type: "NON-CSE",
                itemCategoryId: "",
                unitCost: "0",
                cseId: 0,
                apiId: 0,
                deliveryUnitBudgetItemId: 0,
                isProcurable: false,
            },
            itemCategory: "",
            unit: "",
            // details
            itemDetails: [],
            itemDetailFields: [
                {
                    key: "month.monthName",
                    label: "Month",
                    variant: "primary",
                },
                {
                    key: "quantity",
                    label: "Qty",
                    variant: "primary",
                    thStyle: { width: "120px" },
                },
                {
                    label: "Total",
                    key: "total",
                    variant: "primary",
                    thStyle: { width: "200px" },
                },
            ],
            detail: {
                id: 0,
                monthId: 0,
                quantity: "0",
                totalAmt: 0,
            },
            moveToSaving: null,
            saving: {
                id: 0,
                amount: "0",
                deliveryUnitBudgetItemId: null,
            },
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            slideNo: 0,
            savings: [],
            showSavings: false,
        };
    },
    validations: {
        saving: {
            amount: { required },
        },
    },
    computed: {
        filteredBudget() {
            let data = this.budgetData;
            // var total = this.currentPageBudget * this.perPageBudget;
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.objectOfExpenditure.accountGroup.groupName
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            // var currentData = data.slice(total - this.perPageBudget, total);
            // if (this.currentPageBudget > 1 && currentData.length == 0) {
            //     total = (this.currentPageBudget - 1) * this.perPageBudget;
            //     currentData = data.slice(total - this.perPageBudget, total);
            // }
            var groupedFS = groupBy(data, "fundSource");
            var grouped = [];
            var id = 1;
            var FCID = 1;
            for (const key in groupedFS) {
                var sumBalance = 0;
                var sumAllocated = 0;
                var sumUsed = 0;
                groupedFS[key].forEach((a) => {
                    sumBalance += a.balance;
                    sumAllocated += a.allocated;
                    sumUsed += a.totalWithInflation;
                });
                var group = groupBy(groupedFS[key], "fundClass");
                var FC = [];
                for (const y in group) {
                    FC.push({
                        id: FCID++,
                        data: group[y],
                        key: y,
                    });
                }
                grouped.push({
                    id: id++,
                    fsName: key,
                    balance: sumBalance,
                    allocated: sumAllocated,
                    used: sumUsed,
                    data: FC,
                    fsId: FC[0].data[0].objectOfExpenditure.fundSourceId,
                });
            }
            return grouped;
        },
        rowsBudget() {
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                return this.filteredBudget.length;
            } else {
                return this.budgetData.length;
            }
        },
        filteredResourceItems() {
            let data = this.resourceItems;
            // var total = this.currentPageItem * this.perPageItem;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            let grp = groupBy(data, "apiId");
            let currentData = [];
            for (const key in grp) {
                currentData.push({
                    api: grp[key][0].apiName,
                    data: grp[key],
                });
            }
            // var currentData = data.slice(total - this.perPageItem, total);
            // if (this.currentPageItem > 1 && currentData.length == 0) {
            //     total = (this.currentPageItem - 1) * this.perPageItem;
            //     currentData = data.slice(total - this.perPageItem, total);
            // }
            return currentData;
        },
        rowsResourceItem() {
            if (this.filterItem.trim() != "" && this.filterItem) {
                return this.filteredResourceItems.length;
            } else {
                return this.resourceItems.length;
            }
        },
        totalBudget() {
            var totalBalance = this.selectedBudgetAmount;
            return (totalBalance -= parseFloat(this.detail.totalAmt));
        },
        quantityTotal() {
            var data = this.itemDetails;
            return data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.quantity);
            }, 0);
        },
        amountTotal() {
            var data = this.itemDetails;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            return this.formatCurrency(sum);
        },
        totalSavings() {
            var data = this.savings;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalSavings);
            }, 0);
            return this.formatCurrency(sum);
        },
    },
    created() {
        this.$store
            .dispatch("month/GetAllMonths")
            .then((res) => {
                this.months = res.data;
            })
            .catch((err) => {
                this.showToast("Something went wrong!", "error");
            });
        this.changeCycle(this.$store.state.data.cycle);
    },

    methods: {
        changeCycle(cycle) {
            this.getOfficeBudget(cycle, this.$store.state.data.selectedDU.id);
            this.getMySavings(cycle, this.$store.state.data.selectedDU.id);
        },
        async getMySavings(cycle, deliveryUnitId) {
            await this.$store
                .dispatch("savings/GetMySavings", {cycle, deliveryUnitId})
                .then((res) => {
                    res.data.map((item) => {
                        item.showDetails = false;
                        item.details = [];
                    });
                    this.savings = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        totalResourceItemAmt() {
            var data = this.resourceItems;
            var sum = 0;
            data.forEach((item) => {
                if(!item.mixParentId || item.mixParentId == 0){
                    sum += parseFloat(item.totalWithInflation);
                }
            });
            return this.formatCurrency(sum);
        },
        getOfficeBudget(cycle, deliveryUnitId) {
            this.budgetData = [];
            this.tableBusy = true;
            this.$store
                .dispatch("officebudgetitem/GetMyOfficeBudgetItem", {cycle, deliveryUnitId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        // var date1 = new Date();
                        // var date2 = new Date(item.expiry);
                        // var diffTime = date2 - date1;
                        // var diffDays = Math.ceil(
                        //     diffTime / (1000 * 60 * 60 * 24)
                        // );
                        item.fundClass =
                            item.objectOfExpenditure.accountGroup.fundClassification.classification;
                        item.fundSource =
                            item.objectOfExpenditure.fundSource.sourceName;
                        item.accountGroup =
                            item.objectOfExpenditure.accountGroup.groupName;
                    });
                    this.tableBusy = false;
                    this.budgetData = res.data;
                    this.$refs.carousel.goToPage(0);
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.alert = {
                        type: "danger",
                        message: "Something went wrong!",
                    };
                });
        },
        viewItems(row) {
            this.bliExpired = row.expired;
            this.selectedBudget = row.objectOfExpenditure.accountGroup.groupName;
            this.selectedBudgetId = row.id;
            this.selectedBudgetAmount = row.balance;
            this.selectedResourceStatus = row.status;
            this.budgetIndex = this.budgetData.indexOf(row);
            this.title = "Resource Items";
            this.slideNo = 1;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
            this.getResourceDetails(row.id);
            this.scrollToTop();
        },
        getResourceDetails(id) {
            this.resourceItems = [];
            this.itemLoading = true;
            this.$store
                .dispatch("apiresource/GetResourceItemByBudget", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        var totalQty = 0;
                        item.apiResourceDetails.forEach((x) => {
                            totalQty += x.quantity;
                        });
                        item.quantity = totalQty;
                        item.total =
                            parseFloat(totalQty) * parseFloat(item.unitCost);
                    });
                    this.resourceItems = res.data;
                    this.itemLoading = false;
                })
                .catch(() => {
                    this.itemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        returnToBudget() {
            this.slideNo = 0;
            this.title = "Resources For:";
            this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
        },
        hideModalDetail() {
            this.$bvModal.hide("create-item-modal");
        },
        viewItemLogs({ id }) {
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
        viewResourceItem(props) {
            this.item = cloneDeep(props);
            this.item.unitCost = this.numberWithCommas(props.unitCost.toString());
            this.unit = props.unit.shortName;
            this.itemCategory = props.itemCategory.name;
            this.itemIndex = this.resourceItems.indexOf(props);
            this.selectedBudgetAmount = cloneDeep(
                this.budgetData[this.budgetIndex].balance
            );
            this.modalTitle = "View Resource Item";
            this.$bvModal.show("create-item-modal");
            props.apiResourceDetails.forEach((item) => {
                item.totalAmt =
                    parseFloat(item.quantity) * parseFloat(props.unitCost);
                item.total = this.formatCurrency(item.totalAmt);
            });
            this.itemDetails = props.apiResourceDetails;
        },
        printPPMP(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/PPMP",
                routeVariables: [this.$store.state.data.cycle, id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printRAOS(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Finance/RAOS/DeliveryUnit",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printPPMPCampus() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/Campus/PPMP",
                routeVariables: [this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printPPMPDU() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/PPMP",
                routeVariables: [this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        // async printDULIB() {
        //     this.$refs.printOpt.putOptions({
        //         apiUrl: "api/Report/Planning/LIB/DeliveryUnit",
        //         routeVariables: [this.$store.state.data.cycle],
        //     });
        //     this.$bvModal.show("print-options-modal");
        // },
        async printDraftPPMP() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/Draft/PPMP",
                routeVariables: [this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        addSaving(row) {
            this.moveToSaving = cloneDeep(row);
            this.saving.amount = row.balance.toString();
            this.modalTitle = "Move to Savings";
            this.$bvModal.show("saving-modal");
        },
        async submitSavings() {
            this.submitted = true;
            this.$v.saving.$touch();
            if (this.$v.saving.$invalid) {
                this.submitted = false;
                return;
            }
            if (this.saving.amount > this.moveToSaving.balance) {
                this.showToast(
                    "Amount should not be greater than the budget balance",
                    "error"
                );
                this.submitted = false;
                return;
            }
            await this.$store
                .dispatch("savings/AddSavings", {
                    deliveryUnitBudgetItemId: this.moveToSaving.id,
                    amount: this.getExactAmt(this.saving.amount),
                })
                .then((res) => {
                    if (res.data.error) {
                        this.showToast(res.data.errorMessage, "error");
                    }
                    let data = {
                        fundSource: this.moveToSaving.objectOfExpenditure.fundSource,
                        fundSourceId: this.moveToSaving.objectOfExpenditure.fundSourceId,
                        totalSavings: this.getExactAmt(this.saving.amount),
                    }
                    let index = this.budgetData.findIndex(
                        (x) => x.id == this.moveToSaving.id
                    );
                    this.budgetData[index].balance -= parseFloat(this.getExactAmt(
                        this.saving.amount)
                    );
                    let savingIndex = this.savings.findIndex(
                        (x) =>
                            x.fundSourceId ==
                            this.moveToSaving.objectOfExpenditure.fundSourceId
                    );
                    if(savingIndex == -1){
                        this.savings.push(data);
                    }else{
                        this.savings[savingIndex].totalSavings += parseFloat(this.getExactAmt(
                            this.saving.amount)
                        );
                    }
                    this.showToast("Successfully added", "success");
                    this.$bvModal.hide("saving-modal");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.submitted = false;
        },
        getSavingDetails(row) {
            row.showDetails = !row.showDetails;
            if (row.showDetails && row.details.length == 0) {
                this.$store
                    .dispatch("savings/GetSavingDetails", {
                        id: row.fundSourceId,
                        cycle: this.$store.state.data.cycle,
                        deliveryUnitId: this.$store.state.data.selectedDU.id,
                    })
                    .then((res) => {
                        let data = [];
                        res.data.map(item => {
                            item.accountTrimmed = item.account.toLowerCase().replace(/\s/g, '').trim();
                        })
                        var grouped = groupBy(res.data, "accountTrimmed");
                        for (const key in grouped) {
                            var sum = 0;
                            grouped[key].forEach((a) => {
                                sum += a.amount;
                            });
                            data.push({
                                account: grouped[key][0].account,
                                amount: sum,
                                deliveryUnitBudgetItemId: grouped[key][0].deliveryUnitBudgetItemId,
                                dateTimeAdded: grouped[key][0].dateTimeAdded,
                            });
                        }
                        row.details = data;
                    });
            }
        },
        changeDU(du){
            this.getOfficeBudget(this.$store.state.data.cycle, du.id);
            this.getMySavings(this.$store.state.data.cycle, du.id);
        },
        async printPPMPByApi(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/All/PPMP/API",
                routeVariables: [this.$store.state.data.selectedDU.id, this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="saving-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="submitSavings">
                <div class="mb-2">
                    Balance:
                    {{ moveToSaving && formatCurrency(moveToSaving.balance) }}
                </div>
                <div class="mb-2">
                    <label for="itemName" class="mb-0">Amount</label>
                    <masked-input
                        autocomplete="off"
                        type="text"
                        placeholder="Enter Amount"
                        class="form-control"
                        v-model="saving.amount"
                        :mask="currencyMask"
                    ></masked-input>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-success">
                        Add to Savings
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('saving-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="create-item-modal"
            :title="modalTitle"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <div class="mb-2">
                <label for="itemName" class="mb-0">Item Name</label>
                <input
                    autocomplete="off"
                    type="text"
                    placeholder="Input/Search Item..."
                    class="form-control"
                    disabled
                    v-model="item.itemName"
                />
            </div>
            <b-row class="mb-2">
                <b-col sm="9">
                    <label for="description" class="mb-0">Description </label>
                    <input
                        autocomplete="off"
                        id="name"
                        type="text"
                        v-model="item.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        disabled
                    />
                </b-col>
                <b-col sm="3">
                    <label for="name" class="mb-0">Type </label>
                    <b-form-select
                        id="type"
                        :value="item.type"
                        class="form-select custom-select"
                        disabled
                    >
                        <option></option>
                        <option>CSE</option>
                        <option>NON-CSE</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col sm="5">
                    <label for="itemCategoryId" class="mb-0"
                        >Item Category
                    </label>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Item Category..."
                        class="form-control"
                        :value="itemCategory"
                    />
                </b-col>
                <b-col sm="3">
                    <label for="unitId" class="mb-0">Unit </label>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Unit..."
                        class="form-control"
                        :value="unit"
                    />
                </b-col>
                <b-col sm="4">
                    <label for="unitId" class="mb-0">Unit Cost</label>
                    <input
                        autocomplete="off"
                        id="unitId"
                        type="text"
                        :value="item.unitCost"
                        class="form-control text-right"
                        disabled
                    />
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col sm="4">
                    <label for="unitId" class="mb-0">Procurable?</label>
                    <input
                        autocomplete="off"
                        id="unitId"
                        type="text"
                        :value="item.isProcurable ? 'Yes' : 'No'"
                        class="form-control"
                        disabled
                    />
                </b-col>
                <b-col sm="4">
                    <label for="unitId" class="mb-0">Mixed?</label>
                    <input
                        autocomplete="off"
                        id="unitId"
                        type="text"
                        :value="item.isMixed ? 'Yes' : 'No'"
                        class="form-control"
                        disabled
                    />
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <b-table
                        striped
                        hover
                        :items="itemDetails"
                        :fields="itemDetailFields"
                        show-empty
                    >
                        <template #empty="scope">
                            <div class="text-center">
                                {{ scope.emptyText }}
                            </div>
                        </template>
                        <template #custom-foot>
                            <b-tr>
                                <b-th>Total</b-th>
                                <b-th>{{ quantityTotal }}</b-th>
                                <b-th>{{ amountTotal }}</b-th>
                            </b-tr>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-link"
                    @click="hideModalDetail"
                >
                    Close
                </button>
            </div>
        </b-modal>
        <carousel
            ref="carousel"
            class="events navs-carousel"
            id="timeline-carousel"
            :navigation-enabled="false"
            :pagination-enabled="false"
            :perPage="1"
            :autoplay="false"
            :minSwipeDistance="0"
            :mouseDrag="false"
        >
            <slide>
                <div v-if="slideNo == 0">
                    <div class="row">
                        <div class="col-md-6 d-flex">
                            <div
                                id="tickets-table_filter"
                                class="dataTables_filter me-1"
                            >
                                <label class="d-inline-flex align-items-center">
                                    <b-form-input
                                        autocomplete="off"
                                        v-model="filterBudget"
                                        type="search"
                                        placeholder="Search Budget..."
                                        class="form-control"
                                    ></b-form-input>
                                </label>
                            </div>
                            <div
                                id="tickets-table_length"
                                class="dataTables_length"
                            >
                                <label
                                    class="
                                        d-inline-flex
                                        align-items-center
                                        mb-0
                                    "
                                >
                                    <b-form-select
                                        class="form-select"
                                        v-model="perPageBudget"
                                        size="sm"
                                        :options="pageOptions"
                                    ></b-form-select>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-6 text-right">
                            <!-- <b-dropdown
                                id="dropdown-dropleft"
                                right
                                variant="purple"
                                toggle-class="text-decoration-none"
                                menu-class="dropdown-menu-end"
                                no-caret
                            >
                                <template #button-content>
                                    <i class="bx bx-printer me-1"></i> Reports
                                </template>
                                <b-dropdown-item @click="printPPMPDU()"
                                    >My PPMP</b-dropdown-item
                                >
                                <b-dropdown-item @click="printDraftPPMP()"
                                    >Draft PPMP</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click="printPPMPByApi()"
                                    >PPMP Group by API</b-dropdown-item
                                >
                            </b-dropdown> -->
                        </div>
                        <div class="col-lg-12">
                            <div>
                                <div class="table-responsive">
                                    <table
                                        class="
                                            table
                                            project-list-table
                                            table-centered table-borderless
                                            align-middle
                                        "
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    scope="col"
                                                    width="50px"
                                                ></th>
                                                <th scope="col">Description</th>
                                                <th scope="col" width="250px">
                                                    Budget Allocated
                                                </th>
                                                <th scope="col" width="250px">
                                                    Total Resources
                                                </th>
                                                <th scope="col" width="250px">
                                                    Balance
                                                </th>
                                                <!-- <th scope="col" width="200px">
                                                    Expiry
                                                </th> -->
                                                <th
                                                    scope="col"
                                                    width="150px"
                                                    class="text-center"
                                                >
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="tableBusy">
                                                <td colspan="100%">
                                                    <div
                                                        class="
                                                            d-flex
                                                            justify-content-center
                                                            align-items-center
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                preloader-component
                                                                me-2
                                                            "
                                                        >
                                                            <div class="status">
                                                                <div
                                                                    class="
                                                                        spinner-chase
                                                                        w-20px
                                                                        h-20px
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                v-if="
                                                    budgetData.length == 0 &&
                                                    !tableBusy
                                                "
                                            >
                                                <td
                                                    colspan="100%"
                                                    class="
                                                        text-muted text-center
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            dripicons-warning
                                                            me-1
                                                        "
                                                    ></i
                                                    >No data found
                                                </td>
                                            </tr>
                                            <template
                                                v-for="y in filteredBudget"
                                            >
                                                <tr
                                                    :key="'A' + y.id"
                                                    style="
                                                        background-color: transparent;
                                                        box-shadow: none;
                                                    "
                                                >
                                                    <td
                                                        colspan="2"
                                                        class="py-0"
                                                    >
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                            "
                                                        >
                                                            <span
                                                                class="
                                                                    bx bx-star
                                                                    text-warning
                                                                    me-1
                                                                "
                                                                style="
                                                                    line-height: unset;
                                                                "
                                                            ></span>
                                                            <h5
                                                                class="
                                                                    text-dark
                                                                    mb-0
                                                                    me-2
                                                                "
                                                            >
                                                                {{ y.fsName }}
                                                            </h5>
                                                        </div>
                                                    </td>
                                                    <td class="text-warning font-size-14">
                                                        {{ formatCurrency(y.allocated) }}
                                                    </td>
                                                    <td class="text-warning font-size-14">
                                                        {{ formatCurrency(y.used) }}
                                                    </td>
                                                    <td class="text-warning font-size-14">
                                                        {{ formatCurrency(y.balance) }}
                                                    </td>
                                                    <td></td>
                                                </tr>
                                                <template v-for="z in y.data">
                                                    <tr
                                                        :key="'B' + z.id"
                                                        style="
                                                            background-color: transparent;
                                                            box-shadow: none;
                                                        "
                                                    >
                                                        <td
                                                            colspan="100%"
                                                            class="p-0-20p"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-item-center
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        bx
                                                                        bx-checkbox-square
                                                                        text-success
                                                                        me-1
                                                                    "
                                                                    style="
                                                                        line-height: unset;
                                                                    "
                                                                ></span>
                                                                <b
                                                                    class="
                                                                        text-dark
                                                                    "
                                                                    >{{
                                                                        z.key
                                                                    }}</b
                                                                >
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-for="x in z.data"
                                                        :key="x.id"
                                                        style="
                                                            background-color: transparent;
                                                            box-shadow: none;
                                                        "
                                                    >
                                                        <td></td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                                position-relative
                                                            "
                                                        >   
                                                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()"/>
                                                            <h5
                                                                class="
                                                                    text-truncate
                                                                    font-size-14
                                                                    mb-0
                                                                    d-flex
                                                                "
                                                            >
                                                                <a
                                                                    href="javascript: void(0);"
                                                                    class="
                                                                        text-dark
                                                                    "
                                                                    @click="
                                                                        viewItems(
                                                                            x
                                                                        )
                                                                    "
                                                                    >{{
                                                                        x
                                                                            .objectOfExpenditure
                                                                            .accountGroup
                                                                            .groupName
                                                                    }}</a
                                                                >
                                                                <div>
                                                                    <span
                                                                        class="
                                                                            badge
                                                                            rounded-pill
                                                                            bg-danger
                                                                            float-end
                                                                        "
                                                                        style="
                                                                            font-size: 8px;
                                                                        "
                                                                        >{{
                                                                            x.notification >
                                                                            0
                                                                                ? x.notification
                                                                                : ""
                                                                        }}</span
                                                                    >
                                                                </div>
                                                            </h5>
                                                            <small>
                                                                {{ x.objectOfExpenditure.prexc ? x.objectOfExpenditure.prexc.prexcName : 'No Prexc'}}</small>
                                                            <div>
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-outline-purple
                                                                        btn-sm
                                                                    "
                                                                    @click="
                                                                        printRAOS(
                                                                            x.id
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-printer
                                                                        "
                                                                    ></i>
                                                                    Print
                                                                    RAOS
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            {{
                                                                formatCurrency(
                                                                    x.allocated
                                                                )
                                                            }}
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            {{
                                                                formatCurrency(
                                                                    x.totalWithInflation
                                                                )
                                                            }}
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            <div>
                                                                {{
                                                                    formatCurrency(
                                                                        x.balance
                                                                    )
                                                                }}
                                                            </div>
                                                            <div>
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-outline-success
                                                                        btn-sm
                                                                    "
                                                                    @click="
                                                                        addSaving(
                                                                            x
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-plus
                                                                        "
                                                                    ></i>
                                                                    Add to
                                                                    Savings
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <!-- <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            <span
                                                                v-if="
                                                                    !x.expired
                                                                "
                                                                >Expires on
                                                                {{
                                                                    formatDate(
                                                                        new Date(
                                                                            x.expiry
                                                                        )
                                                                    )
                                                                }}</span
                                                            >
                                                            <span
                                                                v-else
                                                                class="
                                                                    badge
                                                                    bg-warning
                                                                    bg-soft
                                                                    text-warning
                                                                    fs-6
                                                                "
                                                                ><b
                                                                    >Expired</b
                                                                ></span
                                                            >
                                                        </td> -->
                                                        <td
                                                            class="
                                                                text-center
                                                                bg-table-tr
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-center
                                                                "
                                                            >
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    @click="
                                                                        viewItems(
                                                                            x
                                                                        )
                                                                    "
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <span
                                                                        >View
                                                                        Items</span
                                                                    >
                                                                    <i
                                                                        title="View Items"
                                                                        class="
                                                                            mdi
                                                                            mdi-chevron-right
                                                                            font-size-18
                                                                            text-primary
                                                                            cursor-pointer
                                                                        "
                                                                    ></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul class="pagination pagination-rounded mb-0">
                                    <b-pagination
                                        v-model="currentPageBudget"
                                        :total-rows="rowsBudget"
                                        :per-page="perPageBudget"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                </div>
            </slide>
            <slide>
                <div v-if="slideNo == 1">
                    <div class="row">
                        <b-col sm="6">
                            <div class="d-flex align-items-center">
                                <a
                                    href="javascript:void(0);"
                                    class="me-1"
                                    @click="returnToBudget()"
                                    ><i class="bx bx-left-arrow-alt fs-2"></i
                                ></a>
                                <div>
                                    <h4 class="m-0">
                                        {{ selectedBudget }}'s Items
                                    </h4>
                                </div>
                            </div>
                        </b-col>
                        <b-col sm="6" class="text-right">
                            <h4 class="text-muted mb-0">
                                Balance:
                                <b>{{ formatCurrency(totalBudget) }}</b>
                                | Total: <b>{{ totalResourceItemAmt() }}</b>
                            </h4>
                        </b-col>
                    </div>
                    <b-row>
                        <b-col sm="12" class="mt-2">
                            <div class="row">
                                <div class="col-md-6 d-flex">
                                    <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter me-1"
                                    >
                                        <label
                                            class="
                                                d-inline-flex
                                                align-items-center
                                            "
                                        >
                                            <b-form-input
                                                autocomplete="off"
                                                v-model="filterItem"
                                                type="search"
                                                placeholder="Search Items..."
                                                class="form-control"
                                            ></b-form-input>
                                        </label>
                                    </div>
                                    <div
                                        id="tickets-table_length"
                                        class="dataTables_length"
                                    >
                                        <label
                                            class="
                                                d-inline-flex
                                                align-items-center
                                                mb-0
                                            "
                                        >
                                            <b-form-select
                                                class="form-select"
                                                v-model="perPageItem"
                                                size="sm"
                                                :options="pageOptions"
                                            ></b-form-select>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div>
                                        <div class="table-responsive">
                                            <table
                                                class="
                                                    table
                                                    project-list-table
                                                    table-centered
                                                    table-borderless
                                                    align-middle
                                                "
                                            >
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            Item Name
                                                        </th>
                                                        <th scope="col">
                                                            Description
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="120px"
                                                        >
                                                            Qty
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="150px"
                                                        >
                                                            Unit Cost
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="150px"
                                                        >
                                                            Total
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="90px"
                                                            class="text-center"
                                                        >
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="itemLoading">
                                                        <td colspan="100%">
                                                            <div class="d-flex justify-content-center align-items-center">
                                                                <div class="preloader-component me-2">
                                                                    <div class="status">
                                                                        <div class="spinner-chase w-20px h-20px">
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <strong>Loading...</strong>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="filteredResourceItems.length == 0 && !itemLoading">
                                                        <td colspan="6" class="text-muted text-center">
                                                            <i class="dripicons-warning me-1"></i>No data found
                                                        </td>
                                                    </tr>
                                                    <template v-for="(y, yIndex) in filteredResourceItems">
                                                        <tr :key="`firstRow-${yIndex}`" style="background-color: transparent; box-shadow: none;">
                                                            <td colspan="7" class="p-0 position-relative">
                                                                <b>{{y.api}} <span v-if="y.department" class="badge bg-purple">{{y.department}}</span></b>
                                                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" placement="right"/>
                                                            </td>
                                                        </tr>
                                                        <template v-for="x in y.data">
                                                            <tr
                                                                :key="`secondRow-${yIndex}-${x.id}`"
                                                                style="background-color: transparent; box-shadow: none;"
                                                            >
                                                                <td class="position-relative bg-table-tr">
                                                                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()"/>
                                                                    <div>{{ x.itemName }}</div>
                                                                    <div>
                                                                        <small v-if="x.isMixed" class="text-warning">[Mixed]</small>
                                                                    </div>
                                                                </td>
                                                                <td class="bg-table-tr">{{ x.description }}</td>
                                                                <td class="bg-table-tr">{{ x.quantity }}</td>
                                                                <td class="bg-table-tr">{{formatCurrency(x.unitCost)}}</td>
                                                                <td class="bg-table-tr">{{formatCurrency(x.totalWithInflation)}}</td>
                                                                <td class="text-center bg-table-tr">
                                                                    <b-dropdown
                                                                        class="card-drop"
                                                                        menu-class="dropdown-menu-end"
                                                                        variant="white"
                                                                        toggle-class="p-0"
                                                                    >
                                                                        <template v-slot:button-content>
                                                                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                                                                        </template>
                                                                        <b-dropdown-item @click="viewItemLogs(x)" variant="dark">
                                                                            <i class="bx bx-menu-alt-right font-size-18 me-1"></i>View Logs
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item @click="viewResourceItem(x)" variant="dark">
                                                                            <i class="bx bx-edit font-size-18 me-1"></i>View Details
                                                                        </b-dropdown-item>
                                                                    </b-dropdown>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row mb-3">
                                <div class="col mb-3">
                                    <div
                                        class="
                                            dataTables_paginate
                                            paging_simple_numbers
                                            float-end
                                        "
                                    >
                                        <ul
                                            class="
                                                pagination pagination-rounded
                                                mb-0
                                            "
                                        >
                                            <b-pagination
                                                v-model="currentPageItem"
                                                :total-rows="rowsResourceItem"
                                                :per-page="perPageItem"
                                            ></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div> -->
                        </b-col>
                    </b-row>
                </div>
            </slide>
        </carousel>
        <loader :loading="submitted"></loader>
        <api-resource-logs ref="itemlog"></api-resource-logs>
        <print-options ref="printOpt"></print-options>
        <div
            class="
                position-fixed
                d-flex
                justify-content-center
                align-items-center
                flex-column
            "
            style="
                left: 2%;
                bottom: 80px;
                width: 100px;
                height: 100px;
                z-index: 4;
            "
            v-if="slideNo == 0"
        >
            <div
                class="
                    position-relative
                    w-100
                    d-flex
                    justify-content-center
                    align-items-center
                    cursor-pointer
                    on-hover-tada
                "
                @click="showSavings = true"
            >
                <!-- <i class="fas fa-coins text-warning" style="font-size:3rem;"></i> -->
                <!-- <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="50px"
                    height="50px"
                    viewBox="0 0 45.563 45.562"
                    style="enable-background: new 0 0 45.563 45.562"
                    xml:space="preserve"
                    fill="rgb(255, 159, 67, 0.7)"
                >
                    <g>
                        <g>
                            <path
                                d="M18.407,7.816c1.41-0.566,2.873-0.876,4.375-0.876c1.501,0,2.965,0.312,4.374,0.879l2.354-4.373
			c0.393-0.728,0.372-1.601-0.052-2.31C29.035,0.428,28.272,0,27.446,0h-9.327c-0.827,0-1.591,0.428-2.014,1.136
			c-0.424,0.709-0.443,1.585-0.052,2.313L18.407,7.816z"
                            />
                            <path
                                d="M42.664,40.727c-0.453-0.812-1.217-1.602-2.207-2.25c0.258-0.994,0.395-2.127,0.395-3.42
			c0-9.979-8.09-25.637-18.069-25.637C12.801,9.42,4.71,25.076,4.71,35.057c0,1.293,0.137,2.426,0.396,3.42
			c-0.99,0.648-1.754,1.438-2.207,2.25c-0.48,0.858-0.612,1.743-0.295,2.516c0.458,1.107,1.741,1.728,3.342,1.779
			c1.064,0.033,2.269-0.184,3.465-0.677c0.213-0.087,0.418-0.182,0.62-0.282c3.268,1.369,7.774,1.5,12.751,1.5
			c4.976,0,9.481-0.131,12.75-1.5c0.201,0.101,0.407,0.194,0.62,0.282c1.196,0.493,2.4,0.71,3.465,0.677
			c1.602-0.053,2.885-0.672,3.342-1.779C43.276,42.47,43.143,41.585,42.664,40.727z M11.728,26.877
			c-0.879,0-1.592-0.713-1.592-1.592c0-0.88,0.712-1.594,1.592-1.594c0.88,0,1.593,0.714,1.593,1.594
			C13.321,26.164,12.609,26.877,11.728,26.877z M20.391,15.771c-0.039,0.029-3.948,2.927-5.586,5.962
			c-0.292,0.542-0.851,0.851-1.428,0.851c-0.261,0-0.524-0.062-0.768-0.195c-0.788-0.425-1.082-1.408-0.657-2.197
			c1.988-3.683,6.337-6.9,6.521-7.035c0.721-0.529,1.733-0.374,2.265,0.347C21.267,14.226,21.113,15.241,20.391,15.771z"
                            />
                        </g>
                    </g>
                </svg> -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50px"
                    height="50px"
                    viewBox="0 0 64 64"
                >
                    <g class="color000 svgShape" data-name="Money">
                        <path
                            fill="#ffcced"
                            d="M57.5 34.471v-2a1.5 1.5 0 0 0 1.5-1.5V28h2v2.971A3.5 3.5 0 0 1 57.5 34.471zM22 52v6h4V52z"
                            class="colorffc477 svgShape"
                        />
                        <path
                            fill="#ffde17"
                            d="M41.56,14a2.437,2.437,0,0,1-.01.27,9.987,9.987,0,0,1-10.02,9.7,9.869,9.869,0,0,1-5.85-1.91A10.005,10.005,0,1,1,41.56,14Z"
                            class="colorffde17 svgShape"
                        />
                        <path
                            fill="#ffcced"
                            d="M40,52v6h3V52Z"
                            class="colorffc477 svgShape"
                        />
                        <path
                            fill="#ffcd00"
                            d="M41.56,14a2.437,2.437,0,0,1-.01.27,9.987,9.987,0,0,1-10.02,9.7,9.869,9.869,0,0,1-5.85-1.91A77.866,77.866,0,0,0,40.36,9.21,9.923,9.923,0,0,1,41.56,14Z"
                            class="colorffcd00 svgShape"
                        />
                        <path
                            fill="#fb9db8"
                            d="M58.5,33.55c-.01,5.61-2.89,10.67-7.53,14.37L49.43,59H43V52.42a40.964,40.964,0,0,1-10.56,1.56A39.541,39.541,0,0,1,22,52.37V60H16.43L15.21,49.98l-.16-1.34a20.585,20.585,0,0,1-7.44-9.29L3,38.06V28.72l4-1.09.64-.18A17.557,17.557,0,0,1,14,19.44V8.47c-.09-.03.24-.05.58-.05a9.907,9.907,0,0,1,7.27,3.18,10,10,0,1,0,19.7,2.67,26.258,26.258,0,0,1,12.21,7.41A17.628,17.628,0,0,1,58.5,33.55Z"
                            class="colorffdaaa svgShape"
                        />
                        <path
                            fill="#ff6243"
                            d="M30.522,19.994,31,20l0,1,2,.008,0-1.046A3.3,3.3,0,0,0,35.885,16.7v-.381a3.314,3.314,0,0,0-3.3-3.317L32,13v0l-1.462-.006a1.313,1.313,0,0,1-1.3-1.311V11.3A1.31,1.31,0,0,1,30.548,10h0l2.046.007a1.313,1.313,0,0,1,1.3,1.313V12l2,0v-.678A3.284,3.284,0,0,0,33,8.046V7H31V8h-.451a3.312,3.312,0,0,0-3.309,3.3v.38a3.312,3.312,0,0,0,3.3,3.317L31,15v0l1.587.006a1.313,1.313,0,0,1,1.3,1.31V16.7A1.31,1.31,0,0,1,32.577,18h0l-2.046-.007a1.313,1.313,0,0,1-1.3-1.313V16l-2,0v.678a3.312,3.312,0,0,0,3.3,3.317Z"
                            class="colorff6243 svgShape"
                        />
                        <path
                            fill="#57565c"
                            d="M16.009,23.971a3.5,3.5,0,0,0-3.5,3.5h2a1.5,1.5,0,0,1,3,0h2A3.5,3.5,0,0,0,16.009,23.971Z"
                            class="color57565c svgShape"
                        />
                        <path
                            fill="#e6e7e8"
                            d="M48,22v2a4,4,0,0,1,4,4h2A6.006,6.006,0,0,0,48,22Z"
                            class="colore6e7e8 svgShape"
                        />
                    </g>
                </svg>
                <i
                    class="fas fa-coins text-warning position-absolute"
                    style="
                        z-index: 2;
                        bottom: 2px;
                        left: 27px;
                        transform: rotateY(160deg);
                    "
                ></i>
                <i
                    class="fas fa-coins text-warning position-absolute"
                    style="
                        z-index: 2;
                        bottom: 0px;
                        left: 43px;
                        transform: rotateZ(40deg);
                    "
                ></i>
                <i
                    class="fas fa-coins text-warning position-absolute"
                    style="
                        z-index: 2;
                        bottom: 2px;
                        left: 60px;
                        transform: rotateY(170deg);
                    "
                ></i>
            </div>
            <div class="font-size-12">
                Total Savings:
                <div>
                    <span class="text-warning">{{ totalSavings }}</span>
                </div>
            </div>
        </div>
        <div class="position-fixed bg-body savings-card" v-if="showSavings">
            <div class="position-relative">
                <div
                    class="
                        bg-gradient-warning
                        d-flex
                        flex-column-reverse
                        saving-card-banner
                    "
                >
                    <div class="position-absolute saving-card-svg" style="">
                        <div class="position-relative">
                            <svg
                                version="1.1"
                                id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="100px"
                                height="100px"
                                viewBox="0 0 45.563 45.562"
                                style="enable-background: new 0 0 45.563 45.562"
                                xml:space="preserve"
                                fill="#762a0d"
                                stroke="black"
                                stroke-width="1"
                            >
                                <g>
                                    <g>
                                        <path
                                            d="M18.407,7.816c1.41-0.566,2.873-0.876,4.375-0.876c1.501,0,2.965,0.312,4.374,0.879l2.354-4.373
                    c0.393-0.728,0.372-1.601-0.052-2.31C29.035,0.428,28.272,0,27.446,0h-9.327c-0.827,0-1.591,0.428-2.014,1.136
                    c-0.424,0.709-0.443,1.585-0.052,2.313L18.407,7.816z"
                                        />
                                        <path
                                            d="M42.664,40.727c-0.453-0.812-1.217-1.602-2.207-2.25c0.258-0.994,0.395-2.127,0.395-3.42
                    c0-9.979-8.09-25.637-18.069-25.637C12.801,9.42,4.71,25.076,4.71,35.057c0,1.293,0.137,2.426,0.396,3.42
                    c-0.99,0.648-1.754,1.438-2.207,2.25c-0.48,0.858-0.612,1.743-0.295,2.516c0.458,1.107,1.741,1.728,3.342,1.779
                    c1.064,0.033,2.269-0.184,3.465-0.677c0.213-0.087,0.418-0.182,0.62-0.282c3.268,1.369,7.774,1.5,12.751,1.5
                    c4.976,0,9.481-0.131,12.75-1.5c0.201,0.101,0.407,0.194,0.62,0.282c1.196,0.493,2.4,0.71,3.465,0.677
                    c1.602-0.053,2.885-0.672,3.342-1.779C43.276,42.47,43.143,41.585,42.664,40.727z M11.728,26.877
                    c-0.879,0-1.592-0.713-1.592-1.592c0-0.88,0.712-1.594,1.592-1.594c0.88,0,1.593,0.714,1.593,1.594
                    C13.321,26.164,12.609,26.877,11.728,26.877z M20.391,15.771c-0.039,0.029-3.948,2.927-5.586,5.962
                    c-0.292,0.542-0.851,0.851-1.428,0.851c-0.261,0-0.524-0.062-0.768-0.195c-0.788-0.425-1.082-1.408-0.657-2.197
                    c1.988-3.683,6.337-6.9,6.521-7.035c0.721-0.529,1.733-0.374,2.265,0.347C21.267,14.226,21.113,15.241,20.391,15.771z"
                                        />
                                    </g>
                                </g>
                            </svg>
                            <i
                                class="
                                    fas
                                    fa-coins
                                    text-warning
                                    position-absolute
                                "
                                style="
                                    z-index: 2;
                                    bottom: -2px;
                                    left: 10px;
                                    transform: rotateY(160deg);
                                    font-size: 20px;
                                "
                            ></i>
                            <i
                                class="
                                    fas
                                    fa-coins
                                    text-warning
                                    position-absolute
                                "
                                style="
                                    z-index: 2;
                                    bottom: -8px;
                                    left: 36px;
                                    transform: rotateZ(40deg);
                                    font-size: 20px;
                                "
                            ></i>
                            <i
                                class="
                                    fas
                                    fa-coins
                                    text-warning
                                    position-absolute
                                "
                                style="
                                    z-index: 2;
                                    bottom: -2px;
                                    left: 63px;
                                    transform: rotateY(170deg);
                                    font-size: 20px;
                                "
                            ></i>
                        </div>
                    </div>
                    <div
                        class="
                            position-absolute
                            bg-white
                            d-flex
                            align-items-center
                            justify-content-center
                            cursor-pointer
                            savings-btn
                        "
                        @click="showSavings = false"
                    >
                        <i
                            class="bx bx-x text-black font-size-24"
                            style="font-weight: bolder"
                        ></i>
                    </div>
                    <div class="saving-card-set">
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 20px; height: 20px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 30px; height: 30px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 40px; height: 40px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 50px; height: 50px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 40px; height: 40px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 30px; height: 30px"
                            />
                        </div>
                    </div>
                    <div class="saving-card-set set-2">
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 20px; height: 20px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 30px; height: 30px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 40px; height: 40px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 50px; height: 50px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 40px; height: 40px"
                            />
                        </div>
                        <div>
                            <img
                                src="@/assets/images/icons/coin.png"
                                alt="coin"
                                style="width: 30px; height: 30px"
                            />
                        </div>
                    </div>
                    <h4
                        class="text-black mb-0"
                        style="
                            font-weight: 800;
                            margin-left: 125px;
                            z-index: 10;
                        "
                    >
                        Total Savings:
                    </h4>
                </div>
            </div>
            <h4
                class="text-white mt-2"
                style="font-weight: 800; margin-left: 125px"
            >
                {{ totalSavings }}
            </h4>
            <div class="" style="overflow: hidden; height: 350px; width: 100%">
                <h5 class="mb-3 px-3 py-2">Savings Record</h5>
                <div class="savings-record">
                    <div v-for="x in savings" :key="x.id" class="">
                        <div
                            class="
                                d-flex
                                align-items-center
                                justify-content-between
                                cursor-pointer
                                px-3
                                py-2
                            "
                            :class="{ 'bg-gradient-warning': x.showDetails }"
                            @click="getSavingDetails(x)"
                        >
                            <div class="d-flex align-items-center">
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 58 58"
                                    style="enable-background: new 0 0 58 58"
                                    xml:space="preserve"
                                    height="30"
                                    width="30"
                                >
                                    <g>
                                        <g>
                                            <polygon
                                                style="fill: #5e3118"
                                                points="41.528,5.884 55,19.356 54.472,19.884 58,19.884 58,5.884 		"
                                            />
                                            <path
                                                style="fill: #5e3118"
                                                d="M24.174,5.884H7c-3.866,0-7,3.134-7,7s3.134,7,7,7h4.23l-0.528-0.528L24.174,5.884z"
                                            />
                                        </g>
                                        <g>
                                            <path
                                                style="fill: #77442b"
                                                d="M16.543,8.367c-0.641,0.048-1.298,0.08-1.961,0.104c-0.552,0.02-0.983,0.483-0.963,1.035
                                                c0.02,0.54,0.463,0.964,0.998,0.964c0.013,0,0.024,0,0.037-0.001c0.688-0.024,1.371-0.059,2.037-0.108
                                                c0.551-0.041,0.964-0.521,0.923-1.071S17.095,8.324,16.543,8.367z"
                                            />
                                            <path
                                                style="fill: #77442b"
                                                d="M10.588,8.569c-0.696,0.02-1.379,0.045-2.034,0.086c-0.552,0.034-0.971,0.509-0.937,1.06
                                                c0.033,0.53,0.473,0.938,0.997,0.938c0.021,0,0.042-0.001,0.063-0.002c0.634-0.039,1.293-0.064,1.966-0.082
                                                c0.552-0.016,0.987-0.475,0.973-1.027S11.124,8.595,10.588,8.569z"
                                            />
                                            <path
                                                style="fill: #77442b"
                                                d="M4.359,9.319c-0.907,0.297-1.602,0.694-2.12,1.213c-0.391,0.391-0.391,1.023,0,1.414
                                                c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.288-0.287,0.734-0.532,1.329-0.727
                                                c0.524-0.172,0.811-0.736,0.639-1.262C5.45,9.434,4.889,9.146,4.359,9.319z"
                                            />
                                            <path
                                                style="fill: #77442b"
                                                d="M50,8.884h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1h2c0.553,0,1-0.447,1-1S50.553,8.884,50,8.884z"
                                            />
                                            <path
                                                style="fill: #77442b"
                                                d="M56,8.884h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1h2c0.553,0,1-0.447,1-1S56.553,8.884,56,8.884z"
                                            />
                                        </g>
                                        <path
                                            style="fill: #eaead6"
                                            d="M55.556,19.884L35.8,0.156c-0.054-0.054-0.142-0.054-0.196,0L15.849,19.884H55.556z"
                                        />
                                        <path
                                            style="fill: #bfbda3"
                                            d="M15.876,19.884L32.851,2.909l-2.753-2.753c-0.054-0.054-0.142-0.054-0.196,0L10.147,19.884H15.876z"
                                        />
                                        <path
                                            style="fill: #6d8c60"
                                            d="M47.331,20.509l0.309-0.309L35.759,8.335c-0.032-0.032-0.083-0.032-0.115,0L23.769,20.2l0.309,0.309
    H47.331z"
                                        />
                                        <g>
                                            <path
                                                style="fill: #77442b"
                                                d="M0,12.884v38.848c0,3.398,2.754,6.152,6.152,6.152H58v-38H7C3.134,19.884,0,16.75,0,12.884z"
                                            />
                                        </g>
                                        <path
                                            style="fill: #91553d"
                                            d="M52,24.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S52.553,24.884,52,24.884z
                                            M46,24.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S46.553,24.884,46,24.884z M40,24.884h-2
                                            c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S40.553,24.884,40,24.884z M34,24.884h-2c-0.553,0-1-0.447-1-1
                                            s0.447-1,1-1h2c0.553,0,1,0.447,1,1S34.553,24.884,34,24.884z M28,24.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2
                                            c0.553,0,1,0.447,1,1S28.553,24.884,28,24.884z M22,24.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1
                                            S22.553,24.884,22,24.884z M16,24.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S16.553,24.884,16,24.884z
                                            M10,24.884H8c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S10.553,24.884,10,24.884z M4.091,24.254
                                            c-0.139,0-0.28-0.029-0.415-0.091c-0.693-0.317-1.337-0.731-1.914-1.231C1.345,22.569,1.3,21.937,1.661,21.52
                                            c0.363-0.417,0.994-0.462,1.411-0.101c0.433,0.376,0.916,0.687,1.436,0.925c0.502,0.229,0.723,0.823,0.493,1.325
                                            C4.833,24.037,4.471,24.254,4.091,24.254z"
                                        />
                                        <path
                                            style="fill: #91553d"
                                            d="M52,54.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S52.553,54.884,52,54.884z
                                            M46,54.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S46.553,54.884,46,54.884z M40,54.884h-2
                                            c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S40.553,54.884,40,54.884z M34,54.884h-2c-0.553,0-1-0.447-1-1
                                            s0.447-1,1-1h2c0.553,0,1,0.447,1,1S34.553,54.884,34,54.884z M28,54.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2
                                            c0.553,0,1,0.447,1,1S28.553,54.884,28,54.884z M22,54.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1
                                            S22.553,54.884,22,54.884z M16,54.884h-2c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S16.553,54.884,16,54.884z
                                            M10,54.884H8c-0.553,0-1-0.447-1-1s0.447-1,1-1h2c0.553,0,1,0.447,1,1S10.553,54.884,10,54.884z M4.091,54.254
                                            c-0.139,0-0.28-0.029-0.415-0.091c-0.693-0.317-1.337-0.731-1.914-1.231C1.345,52.569,1.3,51.937,1.661,51.52
                                            c0.363-0.417,0.994-0.462,1.411-0.101c0.433,0.376,0.916,0.687,1.436,0.925c0.502,0.229,0.723,0.823,0.493,1.325
                                            C4.833,54.037,4.471,54.254,4.091,54.254z"
                                        />
                                        <path
                                            style="fill: #6d3d25"
                                            d="M58,45.051H46c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h12V45.051z"
                                        />
                                        <path
                                            style="fill: #5e3118"
                                            d="M58,43.884H46c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h12V43.884z"
                                        />
                                        <circle
                                            style="fill: #e4c05c"
                                            cx="47"
                                            cy="37.884"
                                            r="3"
                                        />
                                    </g>
                                </svg>
                                <div class="ms-2">
                                    <p
                                        class="font-size-18 mb-0 text-white"
                                        style="line-height: 1"
                                    >
                                        {{ x.fundSource.sourceName }}
                                    </p>
                                    <small>{{
                                        formatCurrency(x.totalSavings)
                                    }}</small>
                                </div>
                            </div>
                            <div class="h-100">
                                <i
                                    class="
                                        bx bx-chevron-right
                                        font-size-18
                                        rotate
                                    "
                                    :class="{ 'rotate-90': x.showDetails }"
                                ></i>
                            </div>
                        </div>
                        <b-collapse
                            :accordion="`savings-accordion-${x.fundSourceId}`"
                            role="tabpanel"
                            :visible="x.showDetails"
                        >
                            <div
                                class="px-3 py-2"
                                v-for="y in x.details"
                                :key="y.id"
                            >
                                <p class="m-0 font-size-13 text-white">
                                    {{ y.account }}
                                </p>
                                <p class="m-0 font-size-11 text-muted">
                                   on {{ formatDateShort( new Date(y.dateTimeAdded))}}
                                </p>
                                <p
                                    class="
                                        m-0
                                        text-right
                                        font-size-11
                                        text-white
                                    "
                                >
                                    {{ formatCurrency(y.amount) }}
                                </p>
                            </div>
                            <hr class="mt-2" />
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>